import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { SMAlertRule } from '../../model/sm-alertrule';
import { decodeFiwareString } from '../../shared/replacer-util';

export interface SmAlertRuleState extends EntityState<SMAlertRule> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'SmAlertRule' })
export class SmAlertRuleStore extends EntityStore<SmAlertRuleState> {

  constructor() {
    super();
  }
  akitaPreAddEntity(entity: SMAlertRule) {
    return decodeEntity(entity);
  }

  akitaPreUpdateEntity(_: SMAlertRule, newEntity: SMAlertRule) {
    return decodeEntity(newEntity);
  }
}

function decodeEntity(entity: SMAlertRule) {

  const copy = { ...entity }
  copy.name = decodeFiwareString(entity.name);
  copy.errorMessage = decodeFiwareString(entity.errorMessage);
  return copy;
}
